import { render, staticRenderFns } from "./DocRecord.vue?vue&type=template&id=c0d79c38&"
import script from "./DocRecord.vue?vue&type=script&lang=js&"
export * from "./DocRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DocRecord.vue"
export default component.exports